
define('ui-helper/cookie-helper',['jquery'],

function($) {

	function setCookie(key, value, exdays, global) { 
		
	    var now = new Date(); 
	    var expirationDate = new Date(now.getTime() + (exdays*24*60*60*1000)); 

	    var expires = "expires="+expirationDate.toUTCString(); 
	    if(exdays==0)
	    	expires="";
	    var cvalue = key + "=" + value + "; " + expires + "; "
	
	    
	    if("LAST_FLIGHT_SEARCH_DATA" === key){
	    	cvalue += " secure";
	    }
	    
	    if (global) {
	    	cvalue += "path=/; ";			
		}
	    
	    document.cookie = cvalue;

	} 

	

	function getCookie(key) {

		key = $.trim(key) + "=";
	    
	    var keyValuePairs = document.cookie.split(';');

	    var value = null;
	    
	    for(var i=0; i<keyValuePairs.length; i++) {
	    	
	        var keyValuePair = keyValuePairs[i];
	        
	        keyValuePair = $.trim(keyValuePair);
	        
	        if (keyValuePair.indexOf(key) == 0) {
	        	value = keyValuePair.substring(key.length).replace(/"/g, "");

	        	break;
	        }
	        
	    }
	    
	    return value || "";
	}
	function deleteCookie(key){
		setCookie(key,'',-1,true);
	}
	
	return {
		setCookie : setCookie,
		getCookie : getCookie,
		deleteCookie : deleteCookie
	};

});
